module.exports = __webpack_public_path__ + "img/行业应用_数据中心.0e85a0d9.svg";